import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import React, { useState, useEffect } from "react";
import {
  BaseCategory,
  OrderStatus,
  ConflictStatus,
  Product,
  ProductColor,
  Category,
  SubCategory,
  SuperCategory,
} from "@/utils/types";
import {
  PAYS,
  CURRENCIES,
  COLORS,
  wilayas,
  fuelTypes,
  transmissionTypes,
  CarFeatures,
  CarFeaturess,
} from "@/utils/utilLists";
import { styled } from "@mui/system";
import { useTranslation } from "react-i18next";
import {
  createTheme,
  ThemeProvider,
  Theme,
  useTheme,
} from "@mui/material/styles";
import { FilterConditions, SELECT } from "@/utils/database_module";
import { availableName } from "@/utils/fncts";

export default function AutocompleteComponent({
  defaultValue,
  is_multiple,
  onChange,
  itemType,
  filter,
  freeSolo,
}: {
  defaultValue?: any;
  is_multiple: boolean;
  onChange: Function;
  itemType: string;
  filter?: any;
  freeSolo?: boolean;
}) {
  const { t, i18n } = useTranslation();
  const currentLocale = i18n.language as "ar" | "fr" | "en";
  const handleChange = (event: any, value: any) => {
    setSelectedValue(value); // <- bien mettre à jour le state local
    onChange(value); // <- propager au parent
  };

  const [selectedValue, setSelectedValue] = useState(defaultValue);
  const outerTheme = useTheme();
  if (!is_multiple && !defaultValue?.id) defaultValue = undefined;

  console.log(defaultValue);
  const [itemsData, setItemsData] = useState({
    isLoading: true,
    error: false,
    items: [] as any,
  });

  const getOptionLabel = (option: any) => {
    if (itemType == "users")
      return option?.first_name + " " + option?.last_name;
    if (typeof option == "string") return option;
    if (typeof option?.name == "string") return option?.name;
    if (typeof option?.name == "object")
      return availableName(option?.name, currentLocale);
    return availableName(option?.name, currentLocale);
  };

  useEffect(() => {
    async function fetchItems() {
      try {
        if (itemType == "countries") {
          setItemsData({ isLoading: false, error: false, items: PAYS });
          return;
        }
        if (itemType == "fueltypes") {
          setItemsData({ isLoading: false, error: false, items: fuelTypes });
          return;
        }
        if (itemType == "gearbox") {
          setItemsData({
            isLoading: false,
            error: false,
            items: transmissionTypes,
          });
          return;
        }
        if (itemType == "features") {
          setItemsData({ isLoading: false, error: false, items: CarFeaturess });
          return;
        }
        if (itemType == "wilayas") {
          setItemsData({ isLoading: false, error: false, items: wilayas });
          return;
        }

        if (itemType == "currencies") {
          setItemsData({ isLoading: false, error: false, items: CURRENCIES });
          return;
        }

        if (itemType == "colors") {
          setItemsData({ isLoading: false, error: false, items: COLORS });
          return;
        }

        if (itemType == "permissions") {
          setItemsData({
            isLoading: false,
            error: false,
            items: [
              { id: 1, name: "Commandes" },
              { id: 2, name: "Conflits" },
              { id: 3, name: "Categories" },
              { id: 4, name: "Produits" },
              { id: 5, name: "Clients" },
              { id: 6, name: "Parametres" },
              { id: 7, name: "Chats" },
              { id: 8, name: "Véhicules" },
            ],
          });
          return;
        }
        let conditions = [
          { column: "is_deleted", operator: "=", value: 0 },
        ] as FilterConditions;
        if (itemType == "categories") {
          if (filter)
            conditions.push({
              column: "super_category_id",
              operator: "=",
              value: filter.id,
            });
          const superCategories = (await SELECT("categories", {
            conditions: conditions,
          })) as SuperCategory[];
          setItemsData({
            isLoading: false,
            error: false,
            items: superCategories,
          });
          return;
        }

        if (itemType == "super_categories") {
          const categories = (await SELECT("super_categories", {
            conditions: [
              ...conditions,
              { column: "is_cars", operator: "=", value: 0 },
            ],
          })) as Category[];
          setItemsData({ isLoading: false, error: false, items: categories });
          return;
        }
        if (itemType == "cars_super_categories") {
          const categories = (await SELECT("super_categories", {
            conditions: [
              ...conditions,
              { column: "is_cars", operator: "=", value: 1 },
            ],
          })) as Category[];
          setItemsData({ isLoading: false, error: false, items: categories });
          return;
        }

        if (itemType == "sub_categories") {
          if (filter)
            conditions.push({
              column: "category_id",
              operator: "=",
              value: filter.id,
            });
          const subCategories = (await SELECT("sub_categories", {
            conditions: conditions,
          })) as SubCategory[];
          setItemsData({
            isLoading: false,
            error: false,
            items: subCategories,
          });
          return;
        }

        if (itemType == "all_categories") {
          const super_categories = (await SELECT("super_categories", {
            conditions: conditions,
          })) as SuperCategory[];
          const categories = (await SELECT("categories", {
            conditions: conditions,
          })) as Category[];
          const sub_categories = (await SELECT("sub_categories", {
            conditions: conditions,
          })) as SubCategory[];
          const allCategories = [
            ...super_categories,
            ...categories,
            ...sub_categories,
          ];
          setItemsData({
            isLoading: false,
            error: false,
            items: allCategories,
          });
          return;
        }

        if (itemType == "products")
          conditions.push(
            { column: "is_public", operator: "=", value: 1 },
            { column: "is_primary", operator: "=", value: 1 }
          );

        if (itemType == "cars")
          conditions.push(
            { column: "is_public", operator: "=", value: 1 },
            { column: "is_primary", operator: "=", value: 1 }
          );

        const data = (await SELECT(itemType, {
          conditions: conditions,
        })) as unknown as
          | BaseCategory[]
          | Product[]
          | OrderStatus[]
          | ConflictStatus[];
        setItemsData({ isLoading: false, error: false, items: data });
      } catch (error) {
        console.log("Error fetching data:", error);
        setItemsData({ isLoading: false, error: true, items: [] });
      }
    }
    fetchItems();
  }, [itemType, filter]);

  return (
      <AutocompleteStyled
        loading={itemsData.isLoading}
        style={{
          backgroundColor: "#f8f8faa0",
          minHeight: "40px",
          borderRadius: "5px",
          padding: "8px",
          paddingLeft: "20px",
        }}
        getOptionLabel={getOptionLabel}
        multiple={is_multiple}
        id="tags-standard"
        options={
          itemsData.items && Array.isArray(Object.values(itemsData.items))
            ? Object.values(itemsData.items)
            : []
        }
        isOptionEqualToValue={(option: any, value: any) => {
          if (typeof value === "string" && typeof option === "string")
            return option === value;
          if (typeof value === "string" && typeof option === "object")
            return getOptionLabel(option) === value;
          if (typeof value === "object" && typeof option === "string")
            return getOptionLabel(value) === option;
          return option?.id === value?.id;
        }}
        onChange={handleChange}
        defaultValue={selectedValue}
        value={selectedValue}
        freeSolo={freeSolo}
        renderInput={(params) => (
          <ThemeProvider theme={customTheme(outerTheme)}>
            <TextField
              {...params}
              variant="standard"
              label=""
              placeholder={t("search")}
            />
          </ThemeProvider>
        )}
      />
  );
}

const AutocompleteStyled = styled(Autocomplete)`
  & input {
    font-family: "Plus Jakarta Sans";
    font-size: 15px;
    color: #16489f;
    /* height: 40px; */
  }
  & div::before {
    border-bottom: 0px solid #eee;
  }
  & div::after {
    border-bottom: 0px solid #eee;
  }
  .css-1cdlfj0-MuiInputBase-root-MuiInput-root:hover:not(
      .Mui-disabled,
      .Mui-error
    ):before {
    border-bottom: 0px solid #eee;
  }
`;

const customTheme = (outerTheme: Theme) =>
  createTheme({
    palette: {
      mode: outerTheme.palette.mode,
    },
    components: {
      MuiTextField: {
        styleOverrides: {
          root: {
            "--TextField-brandBorderColor": "#E0E3E7",
            "--TextField-brandBorderHoverColor": "#B2BAC2",
            "--TextField-brandBorderFocusedColor": "#6F7E8C",
            "& label.Mui-focused": {
              color: "# eee",
            },
          },
        },
      },
      MuiInput: {
        styleOverrides: {
          root: {
            "&::before": {
              borderBottom: "0px solid var(--TextField-brandBorderColor)",
            },
            // "&:hover:not(.Mui-disabled, .Mui-error):before": {
            //   borderBottom: "0px solid var(--TextField-brandBorderHoverColor)",
            // },
            "&.Mui-focused:after": {
              borderBottom:
                "0px solid var(--TextField-brandBorderFocusedColor)",
            },
          },
        },
      },
    },
  });
